import { render, staticRenderFns } from "./CreatorRecomendation.vue?vue&type=template&id=76879172&"
import script from "./CreatorRecomendation.vue?vue&type=script&lang=js&"
export * from "./CreatorRecomendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports